module.exports = __webpack_public_path__ + "static/media/bounds_triangle1.9cb12dc7.jpg";